import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonus" className="border-y border-grape/10 bg-white/70" data-id="element-17" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl px-5 py-12" data-id="element-18" data-mp="authf9yat5xk">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-19" data-mp="fteej0i979hs">
          🎁 5 Bonus Gratuits Inclus
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-plum/60" data-id="element-20" data-mp="1t3ofzorpyxo">
          En plus de l'ebook principal, vous recevez également ces cadeaux — sans frais
          supplémentaires.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-21" data-mp="3o3ptu3kvq2xz">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex flex-col rounded-2xl border border-grape/20 bg-cream p-6" data-id="element-22" data-mp="3t2smspnl4ipl" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-23" data-mp="3dd8xsz8x2xrj">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-24" data-mp="3r5yqfmiyb0xm">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-25" data-mp="2zfam61lzdffq" /> Bonus {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-26" data-mp="2ugh9ucifjuh5">
                  <span className="text-plum/40 line-through" data-id="element-27" data-mp="2uhsleyi4a6it">{b.price}</span>{' '}
                  <span className="text-blush-deep" data-id="element-28" data-mp="38hbj0xdaxzgv">GRATUIT</span>
                </span>
              </div>
              <div className="flex gap-4" data-id="element-29" data-mp="33ge36rfrlhij">
                <img src={b.cover} alt={`Couverture — ${b.title}`} loading="lazy" className="h-auto w-[88px] shrink-0 self-start rounded-lg object-contain shadow-[0_12px_28px_-14px_rgba(67,32,26,0.55)] sm:w-[104px]" data-id="element-30" data-mp="33jid85fwv7h4" />
                <div className="min-w-0" data-id="element-31" data-mp="3hhzmhif70bdx">
                  <h3 className="text-base font-bold text-plum" data-id="element-32" data-mp="3hgyc7g603sx9">{b.title}</h3>
                  <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-plum/65" data-id="element-33" data-mp="3lj334752ebg7">
                    {b.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-blush/40 bg-blush-soft p-6 text-center" data-id="element-34" data-mp="2ttzw4jlsmmzv">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-35" data-mp="2xujs3jumrkkf">
            💰 Valeur totale des bonus : <span className="text-plum/50 line-through" data-id="element-36" data-mp="32rjzby37utd4">250€</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-37" data-mp="37k3c4su2xkgv">
              AUJOURD'HUI GRATUIT AVEC CORÉEN EXPRESS
            </span>
          </p>
        </div>
      </div>
    </section>;
}